import TermAndCondintion from "../pages/Guest/TermAndCondintion"
import WellnessPlan from "../pages/Guest/Services/WellnessPlan"
import Testimonials from "../pages/Guest/About/Testimonials"
import ForgotPassword from "../pages/Guest/ForgotPassword"
import SpecialistSignup from "../pages/Specialist/Signup"
import CookiesPolicy from "../pages/Guest/CookiesPolicy"
import PrivacyPolicy from "../pages/Guest/PrivacyPolicy"
import RefundPolicy from "../pages/Guest/RefundPolicy"
import ResetPassword from "../pages/Guest/ResetPassword"
import Coaching from "../pages/Guest/Services/Coaching"
import Services from "../pages/Guest/Services/Services"
import Workshop from "../pages/Guest/Services/Workshop"
import Verification from "../pages/Guest/Verification"
import Courses from "../pages/Guest/Services/Courses"
import GuestOnly from "../layout/Protected/GuestOnly"
import NoSpecialist from "../layout/Protected/NoSpecialist"
import Forum from "../pages/Guest/Community/Forum"
import HelpCenter from "../pages/Guest/HelpCenter"
import Mission from "../pages/Guest/About/Mission"
import Faqs from "../pages/Guest/About/Faqs"
import Pricing from "../pages/Guest/Pricing"
import SubscriptionThankYou from "../pages/Guest/SubscriptionThankYou"
import Signup from "../pages/Guest/Signup"
import Login from "../pages/Guest/Login"
import { Route } from "react-router-dom"
import Home from "../pages/Guest/Home"
import Layout from "../layout/guest"

// Blogs components
import SingleBlogCategory from "../pages/Guest/Blogs/Category"
import SingleBlog from "../pages/Guest/Blogs/SingleBlog"
import AllBlogs from "../pages/Guest/Blogs/AllBlogs"

// Forum components
import SingleForumCategory from "../pages/Guest/Services/Forums/Category"
import ForumsCategories from "../pages/Guest/Services/Forums/Categories"
import SingleForum from "../pages/Guest/Services/Forums/Single"

// Webinar components
import WebinarCategoryPage from "../pages/Guest/Webinar/WebinarCategory"
import SingleWebinars from "../pages/Guest/Webinar/SingleWebinars"
import AllWebinars from "../pages/Guest/Webinar/AllWebinars"

// Specilalist components
import SingleSpecilalist from "../pages/Guest/specialist/SingleSpecilalist"
import AllSpecialists from "../pages/Guest/specialist/AllSpecialists"

// Other components
import Questionnaire from "../pages/Guest/Find/Questionnaire"
import GlobalSearch from "../pages/Guest/GlobalSearch"
import Results from "../pages/Guest/Find/Results"
import Specialist from "../pages/Guest/specialist"
import FindSpecialistProtected from "../layout/Protected/FindSpecialist"
import SpecialistDetails from "../pages/Guest/Find/Results/SpecialistDetails"
import ResourceDetails from "../pages/Guest/Find/Results/ResourceDetais"

import FeatureGuard from "../components/subscription/FeatureGuard"
import MemberOrGuestRoute from "components/common/MemberOrGuestRoute"

const GuestRoutes = (

  <Route path="/" element={<Layout />}>


    <Route path="" element={<Home />} />
    <Route path="faqs" element={<Faqs />} />
    <Route path="home" element={<Home />} />
    <Route path="forums" element={<Forum />} />
    <Route path="blogs" element={<AllBlogs />} />
    <Route path="webinars" element={<AllWebinars />} />
    <Route path="webinar/:webinarId" element={<SingleWebinars />} />
    <Route path="/webinar-category/:categoryId" element={<WebinarCategoryPage />} />

    <Route path="register" element={<Signup />} />
    <Route path="pricing" element={<NoSpecialist><Pricing /></NoSpecialist>} />
    <Route path="subscription-thank-you" element={<SubscriptionThankYou />} />
    <Route path="services" element={<Services />} />
    <Route path="our-mission" element={<Mission />} />
    <Route path="help-center" element={<HelpCenter />} />
    <Route path="blog/:blogId" element={<SingleBlog />} />
    <Route path="global/search" element={<GlobalSearch />} />
    {/* <Route path="all-specialists" element={<AllSpecialists />} /> */}
    <Route
      path="all-specialists"
      element={
        <MemberOrGuestRoute>
          <AllSpecialists />
        </MemberOrGuestRoute>
      }
    />
    <Route
      path="specialist"
      element={
        <MemberOrGuestRoute>
          <Specialist />
        </MemberOrGuestRoute>
      }
    />
    <Route
      path="specialist/:id"
      element={
        <MemberOrGuestRoute>
          <FeatureGuard feature="SPECIALIST_PROFILE_VIEW">
            <SingleSpecilalist />
          </FeatureGuard>
        </MemberOrGuestRoute>
      }
    />

    <Route path="group-workshops" element={<Workshop />} />
    <Route path="testimonials" element={<Testimonials />} />
    <Route path="forum/:forumId" element={<SingleForum />} />
    <Route path="cookie-policy" element={<CookiesPolicy />} />
    <Route path="self-guided-courses" element={<Courses />} />
    <Route
      path="matching-specialist"
      element={
        <MemberOrGuestRoute>
          <Results />
        </MemberOrGuestRoute>
      }
    />
    <Route
      path="matching-specialist/specialist-details"
      element={
        <MemberOrGuestRoute>
          <SpecialistDetails />
        </MemberOrGuestRoute>
      }
    />
    <Route
      path="matching-specialist/resource-details"
      element={
        <MemberOrGuestRoute>
          <ResourceDetails />
        </MemberOrGuestRoute>
      }
    />
    <Route path="one-on-one-coaching" element={<Coaching />} />
    <Route path="privacy-policy" element={<PrivacyPolicy />} />
    <Route path="refund-policy" element={<RefundPolicy />} />
    <Route path="reset-password" element={<ResetPassword />} />
    <Route path="forgot-password" element={<ForgotPassword />} />
    <Route path="community-forums" element={<ForumsCategories />} />
    <Route path="account-verification" element={<Verification />} />
    <Route path="login" element={<GuestOnly><Login /></GuestOnly>} />
    <Route path="custom-wellness-plans" element={<WellnessPlan />} />
    <Route path="terms-and-conditions" element={<TermAndCondintion />} />
    <Route path="specialist-registration" element={<SpecialistSignup />} />
    <Route path="blog-category/:categoryId" element={<SingleBlogCategory />} />
    <Route path="forum-category/:categoryId" element={<SingleForumCategory />} />


    <Route element={<FindSpecialistProtected />}>
      <Route path="find-specialist" element={<Questionnaire />} />
    </Route>
  </Route>
)

export default GuestRoutes